import { useState } from "react";

const GamesDone = () => {
    const [isActive, setIsActive] = useState(false);

    const [time, setTime] = useState("cette semaine");

    const updateStats = (e) => {
        const text = e.target.innerText;
        setTime(text);
        setIsActive(false)
    };

  return (
    <div className="games-done stat-card">
        <div className="title">
            <h4>Nombre de jeux terminés</h4>
            <div className="time-range-selector">
                <div name="timeRange" id="timeRangeSelector" onClick={() => setIsActive(!isActive)}>
                    <p>{time}</p>
                    {/* <p><?= ucfirst($_GET['period'] ?? 'cette semaine') ?></p> */}
                </div>
                <div className={`time-range-choices ${isActive ? "open" : ""}`}>
                    <p onClick={updateStats}>Cette semaine</p>
                    <p onClick={updateStats}>Ce mois-ci</p>
                    <p onClick={updateStats}>Cette année</p>
                    <p onClick={updateStats}>Aujourd'hui</p>
                </div>
            </div>
        </div>
        <span>60</span>
        {/* <span><?= $gamesPlayed ?></span> */}
    </div>
  );
};

export default GamesDone;